import { useLocalePreference } from '~/composables/useLocalePreference'
import { useLocaleRestore } from '~/composables/useLocaleRestore'
import { useLogger } from '~/composables/useLogger'
import { supportedLocaleSchema } from '~/utils/supportedLocaleSchema'

export default defineNuxtPlugin((nuxtApp) => {
  const preference = useLocalePreference()
  const restoreLocale = useLocaleRestore()
  const logger = useLogger('LocalePreference')
  const redirectedCookie = useCookie('i18n_redirected', { path: '/' })

  nuxtApp.hook('app:mounted', async () => {
    redirectedCookie.value = null
    try {
      await restoreLocale()
    } catch (error: unknown) {
      logger.error('restoreLocale', { error })
    }

    // Registered after mount so detection-time switches are never saved as a choice.
    nuxtApp.hook('i18n:localeSwitched', ({ newLocale }) => {
      const parsed = supportedLocaleSchema.safeParse(newLocale)
      if (parsed.success) preference.set(parsed.data)
    })
  })
})
